import React from "react";
import { useDispatch } from "react-redux";
import { setListingData } from "../../store/listing/listingSlice";
import { IconTypes, RenderIcons } from "./icons";

const _props = {
  dataTemplate: "",
  reset:Boolean,
  setReset:()=>{}
};
const ResetData = (props = _props) => {
  const dispatch = useDispatch();
  return (
    <div className="document_header document_icon">
      <span
        className={`reset_icon ${props.reset ? '' : ' disabled'}`}
        onClick={props.reset ? () => {
          dispatch(
            setListingData({ fields: [], template: props.dataTemplate })
          );
          props.setReset(false);
        }:null}
        
      >
        {RenderIcons(IconTypes.Reset)} {/* refer icons.js */}
      </span>
    </div>
  );
};

export default ResetData;
